var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgSomeRss = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.172 11.134V8C17.7 8 25.43 15.718 25.43 25.23h-3.14c0-7.784-6.322-14.096-14.12-14.096m0 6.267v-3.133c6.067 0 10.98 4.905 10.98 10.963h-3.138c0-4.32-3.516-7.83-7.842-7.83m4.836 5.415a2.416 2.416 0 0 1-2.418 2.414 2.416 2.416 0 0 1-2.418-2.414 2.416 2.416 0 0 1 2.418-2.414 2.416 2.416 0 0 1 2.418 2.414",
    clipRule: "evenodd"
  })));
};
const Memo = /*#__PURE__*/memo(SvgSomeRss);
export default Memo;